<template>
    <div class="row">
        <div class="col-md-12 mb-3">
            <div v-bind:class="{disabled: !saveButtonEnabled}" class="pull-right btn btn-primary cursor-pointer" v-on:click="createOrUpdate()">
                Save
            </div>
        </div>
        <div class="col-md-7">
            <div class="row mb-4">
                    <div class="instagram-filters col-md-6 mb-2">
                        <date-range-picker
                            ref="picker"
                            :opens="pickerOptions.opens"
                            :locale-data="pickerOptions.localeDate"
                            :timePicker="false"
                            :timePicker24Hour="false"
                            :showWeekNumbers="false"
                            :showDropdowns="true"
                            :autoApply="true"
                            v-model="dateRange"
                            :linkedCalendars="true"
                            @update="resetFilters()"
                        >
                            <div slot="input" slot-scope="picker" >
                                {{ picker.startDate | date }} - {{ picker.endDate | date }}
                            </div>
                        </date-range-picker>
                    </div>
                    <div class="col-md-6 mb-2">
                        <element-selector @input="resetFilters" :elements="jwtHashtags" v-model="selectedHashtags" />
                    </div>
            </div>
            <div class="card">
                <div class="card-header container-header">
                    Select Images to be included in the widget
                </div>
                <div class="card-body" style="padding: 0 15px;">
                    <div v-infinite-scroll="infiniteHandler" infinite-scroll-disabled="busy" infinite-scroll-distance="10" class="row" style="height:600px; overflow: auto;">
                        <div v-bind:class="{'image-already-selected': widgetContainsPost(post)}" v-on:click="addPostToWidget(post)" class="col-md-3" style="cursor: pointer; padding-top: 25%; overflow:hidden;" v-bind:style="{'background-image': 'url(' + post.thumbnailUrl + ')', 'background-size': 'cover'}" v-for="post in validPosts">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-5">
            <div class="card">
                <div class="card-body widget-info">
                    <div class="row">
                        <div class="form-group col-md-12">
                            <div class="row">
                                <label class="col-md-12" for="title">Widget Name *</label>
                                <div class="col-md-12">
                                    <input id="title" v-model="widget.settings.title" type="text" class="form-control" placeholder="Enter widget name"/>
                                </div>
                                <div v-if="!pristine && (widget.settings.title == null || widget.settings.title  == '')" class="error col-md-12 mt-2">
                                    <span>This field is required</span>
                                </div>
                            </div>
                        </div>
                       <div class="form-group col-md-12">
                           <div class="row">
                               <label class="col-md-12" for="popup-title">Popup Title *</label>
                               <div class="col-md-12">
                                   <input id="popup-title" v-model="widget.settings.modalDescription" type="text" class="form-control" placeholder="Enter widget name"/>
                               </div>
                           </div>
                       </div>
                        <div class="form-group col-md-12">
                            <div class="row">
                                <label class="col-md-12" for="popup-button-text">Popup Button Text *</label>
                                <div class="col-md-12">
                                    <input id="popup-button-text" v-model="widget.settings.modalButton" type="text" class="form-control" placeholder="Enter popup button text"/>
                                </div>
                                <div v-if="!pristine && (widget.settings.modalButton == null || widget.settings.modalButton  == '')" class="error col-md-12 mt-2">
                                    <span>This field is required</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-12">
                            <div class="row">
                                <label class="col-md-12" for="popup-action">Where should we redirect your users after performing an action? *</label>
                                <div class="col-md-12">
                                    <input id="popup-action" v-model="widget.settings.action" type="text" class="form-control" placeholder="Enter popup action"/>
                                </div>
                                <div v-if="!pristine && (widget.settings.action == null || widget.settings.action  == '')" class="error col-md-12 mt-2">
                                    <span>This field is required</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 container-header">
                            Selected Images
                        </div>
                        <div v-cloak class="col-md-12 mt-3 mb-3" v-if="!widget.posts.length">
                            No Images selected yet
                        </div>
                        <div class="col-md-3" style="position:relative;" v-bind:key="post.id" v-bind:style="{'background-image': 'url(' + post.imageUrl + ')', 'background-size': 'cover', 'padding-top': '25%'}" v-for="(post, idx) in widget.posts">
                            <div class="close-button" v-on:click="removePostFromWidget(idx)" >
                                <i class="fas fa-times"></i>
                            </div>
                        </div>
                        <div v-if="!pristine && widget.posts.length < 4" class="error col-md-12 text-center mt-2">
                            <span>You must select at least 4 images</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style>
    .reportrange-text {
        height: 40px;
    }
    .card .card-body.widget-info{
        padding-bottom: 0;
    }
    .container-header {
        background: #00aef1;
        padding: 10px;
        color: white;
        font-weight: bold;
    }
    .close-button {
        position: absolute;
        right: 0;
        top: 0;
        width: 25px;
        height: 25px;
        text-align: center;
        color: black;
        font-size: 15px;
        cursor: pointer;
        background: white;
        padding-top: 2px;
    }
    .image-already-selected:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: #00ff78;
        opacity: 0.7;
    }
</style>
<script>
    import jwtDecode from 'jwt-decode'
    import infiniteScroll from 'vue-infinite-scroll'
    import InstagramService from "../../services/instagram-service"
    import DateRangePicker from 'vue2-daterange-picker'
    import Multiselect from 'vue-multiselect'
    import InstagramMixin from "./InstagramMixin";
    import ElementSelector from "./components/ElementSelector";

    Vue.use(infiniteScroll)

    export default {
        components: { DateRangePicker, Multiselect, ElementSelector },
        mixins: [InstagramMixin],
        data: function() {
            return {
                page: 1,
                lastPage: null,
                total: null,
                order: 'totalEngagement',
                sort: 'desc',
                pristine: true,
                saveButtonEnabled: true,
                busy: false,
                posts: [],
                widget: {
                    settings: {
                        title: '',
                        actionType: 'redirect',
                        action: '',
                        modalButton: '',
                        modalDescription: '',
                    },

                    posts:[]
                },
            }
        },
        computed: {
            validPosts() {
                return this.posts.filter(post => {
                    return post.imageUrl != null
                });
            }
        },
        methods: {
            resetFilters() {
                this.page = 1
                this.posts = []
                this.infiniteHandler()
            },
            widgetContainsPost(post) {
                const postExistsInWidget = this.widget.posts.find(widgetPost => widgetPost.id === post.postId)
                return postExistsInWidget
            },
            addPostToWidget(post) {
                if(this.widgetContainsPost(post)) {
                    const index = this.widget.posts.findIndex(widgetPost => widgetPost.id === post.postId)
                    this.widget.posts.splice(index, 1)
                    return
                }

                this.widget.posts.push({
                    id: post.postId,
                    imageUrl: post.thumbnailUrl,
                    likes: post.totalLikes
                })
            },
            removePostFromWidget(idx) {
                this.widget.posts.splice(idx, 1)
            },
            async infiniteHandler() {
                this.busy = true
                const params = {
                    filters: {},
                    from: this.dateRange.startDate,
                    to: this.dateRange.endDate,
                    sortBy: this.order,
                    sortOrder: this.sort
                }

                if (!this.selectedHashtags.length) {
                    params.hashtags = this.jwtHashtags.join(',')
                } else {
                    params.hashtags = this.selectedHashtags.join(',')
                }

                const posts = await InstagramService.v2.posts.index(Object.assign({}, params, {
                    limit: 50,
                    page: this.page
                }))

                this.page += 1
                if (posts.data.length === 0) {
                    this.busy = true
                    return
                }
                this.posts.push(...posts.data)
                this.busy = false
            },
            validateData() {
                this.pristine = false
                if (this.widget.posts.length < 4) return false
                if (this.widget.settings.title == null || this.widget.settings.title == '') return false
                if (this.widget.settings.modalButton == null || this.widget.settings.modalButton == '') return false
                if (this.widget.settings.action == null || this.widget.settings.action == '') return false
                return true
            },
            async createOrUpdate() {
                if(!this.saveButtonEnabled) return
                if (!this.validateData()) return

                // this.saveButtonEnabled = false

                const dataToSend = Object.assign({}, this.widget)
                dataToSend.posts = dataToSend.posts.map(post => {
                    return {id: post.id}
                })

                delete dataToSend.id
                if (this.widget.id) {
                    await InstagramService.widgets.update({id: this.widget.id, data: dataToSend})

                } else {
                    await InstagramService.widgets.create({data: dataToSend})
                }

                window.location.href = '/social/#promote'
            }
        },
        async mounted() {
            let id = window.location.href.split('/').slice(-1)[0]

            if(id !== 'new') {
                const widget = await InstagramService.v2.widgets.get({id})
                this.widget = widget
            }
        }
    }
</script>
